

module.exports = __webpack_require__.stylable.create(
    "DropdownOption1593226040",
    {"classes":{"root":"DropdownOption1593226040__root","highlight":"DropdownOption1593226040__highlight","nonHighlight":"DropdownOption1593226040__nonHighlight"},"vars":{},"stVars":{"hoverBackgroundColor":"lightgrey","selectedBackgroundColor":"grey","selectedHoverBackgroundColor":"dimgrey","disabledBackgroundColor":"white"},"keyframes":{}},
    "",
    1,
    "DropdownOption1593226040",
    null
);
